import React, { useState, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";

import {
  FormGroup,
  Select,
  StatusDot,
  Checkbox,
  Subheader,
  Head,
  Button,
  Card,
  Input,
  RadioGroup,
  Breadcrumbs,
  Icon,
  FormFooter,
  ContentBlock,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";


export default function PApn() {
  return (


        <FormGroup indentation="lg">
          Partner Network
        </FormGroup>


  )
}
